export const setDefaultAccentColors = () => {
  const rootStyle = document.querySelector(':root').style;
  rootStyle.setProperty('--accentColorPrimaryBackground', '#feb80a');
  rootStyle.setProperty('--accentColorPrimaryText', '#fff');
  rootStyle.setProperty('--accentColorSecondaryBackground', '#012f34');
  rootStyle.setProperty('--accentColorSecondaryText', '#fff');
};
